import { useState } from "react";

export default function Section18() {
  const faqs = [
    {
      question: "How much does professional web development cost in New York? ",
      answer:
        "Costs for web development vary depending on the complexity, design requirements, and features. Simple informational websites typically start around $5,000–$10,000, while custom, scalable, or enterprise-level solutions can range $20,000+",
    },
    {
      question: "Can you migrate my existing website to a new platform?",
      answer:
        "Yes. Mean3 handles platform migrations from CMSs like WordPress, Magento, or Joomla while preserving SEO, content, and data integrity. We ensure smooth transitions with minimal disruption to your users or search rankings",
    },
    {
      question: "Can you create custom web designs that reflect my brand identity? ",
      answer:
        "Yes. Mean3 designs custom websites that reflect your brand, ensuring a professional look, consistent branding, and layouts that guide visitors toward key actions and conversions.",
    },
    {
      question: "Do you offer e-commerce website development?",
      answer:
        "Absolutely. We build scalable, conversion-focused ecommerce websites on platforms like Shopify, Magento, WooCommerce, and custom solutions, optimized for sales, speed, and user experience.",
    },
    {
      question: "How do you ensure website security?",
      answer:
        "We implement industry-standard security practices, including SSL certificates, secure coding, regular updates, and vulnerability scanning, ensuring your website and customer data remain protected.",
    },
    {
      question: "Do you provide content strategy or copywriting for websites? ",
      answer:
        "Yes. We offer conversion-focused content strategy and copywriting, ensuring that your website’s messaging engages visitors, aligns with your brand, and supports SEO goals.",
    },
    {
      question: "Can you integrate my website with CRM, marketing, or analytics tools?",
      answer:
        "Absolutely. We integrate CRMs, email marketing platforms, analytics, payment gateways, and other essential systems to streamline business operations and enhance functionality.",
    },
    
    {
      question: "What services are included in web development and design?",
      answer:
        "We provide custom website design, advanced development, third-party integrations, platform migration, and ongoing support & maintenance. Each website is optimized for speed, responsiveness, SEO, and conversions.",
    },
    {
      question: "Do you optimize websites for SEO and performance?",
      answer:
        "Yes. Every website is optimized for search engines, site speed, structured data, and user experience, helping you rank higher, attract more visitors, and convert them effectively.",
    },
  ];

  const [isOpen, setIsOpen] = useState(new Array(faqs.length).fill(false));

  const handleFaq = (index) => {
    setIsOpen((prevState) =>
      prevState.map((item, idx) => (idx === index ? !item : false))
    );
  };

  return (
    <div className="w-full SectionWebsiteFAQs mt-[8%] md:mt-[-4%]">
      <div className="w-full section-container">
        <div className="w-[90%] md:w-[61%] pb-[1%] mx-auto text-center">
          <h2 className="leading-[29px] md:leading-[41px] text-[24px] md:text-[30px] text-[#151515] font-bold my-[0.67em]">
          FAQs 
          </h2>
        </div>

        <div className="w-full md:w-[784px] p-5 md:p-[2%] mx-auto faq-container font-open leading-[21px]">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
              // style={{
              //   background:
              //     "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
              // }}
            >
              <div
                onClick={() => handleFaq(index)}
                className="question text-[#444444] cursor-pointer flex justify-between items-center"
              >
                {faq.question}
                <b className="text-[40px] text-[#DA2128] font-[300]">
                  {isOpen[index] ? "-" : "+"}
                </b>
              </div>
              <div className={`${isOpen[index] ? "block" : "hidden"} answer text-[#444444]`}>
                <br />
                <p className="mb-5">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-8">
          <a
            href="https://mean3.com/contact-mean3"  // replace with your desired link if different
            className="bg-[#DA2128] hover:bg-[#b71c22] text-white px-8 py-3 rounded-lg font-semibold text-[15px] md:text-[16px] transition-all duration-300 inline-block text-center"
          >
            Ask Your Question
          </a>

        </div>
      </div>

      {/* Divider Line */}
      <div className="line mb-[55px] md:mb-[4%] mt-[1%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
